/**
 * @flow
 * @relayHash 51fc48c9335397fdee0e2e3423dbcdae
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POReviewFormItemsQueryVariables = {|
  search?: ?string
|};
export type POReviewFormItemsQueryResponse = {|
  +items: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
        +quantityUOM: {|
          +id: string,
          +name: string,
          +symbol: string,
        |},
      |}
    |}>
  |}
|};
export type POReviewFormItemsQuery = {|
  variables: POReviewFormItemsQueryVariables,
  response: POReviewFormItemsQueryResponse,
|};
*/


/*
query POReviewFormItemsQuery(
  $search: String
) {
  items(first: 300, search: $search) {
    edges {
      node {
        id
        name
        quantityUOM {
          id
          name
          symbol
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "items",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 300
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "ItemConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "quantityUOM",
                "storageKey": null,
                "args": null,
                "concreteType": "UOM",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "symbol",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "POReviewFormItemsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "POReviewFormItemsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "POReviewFormItemsQuery",
    "id": null,
    "text": "query POReviewFormItemsQuery(\n  $search: String\n) {\n  items(first: 300, search: $search) {\n    edges {\n      node {\n        id\n        name\n        quantityUOM {\n          id\n          name\n          symbol\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '63b4167f42a463fe1e16d35d14f7fa49';
module.exports = node;
